<template>
  <div class="chart-field" v-loading="chartLoading">
    <div class="chart-title">{{ title }}</div>
    <div v-show="chartData.dataTrendList.length > 0" style="height: 400px">
      <div style="height: 400px" ref="chartRef"></div>
    </div>
    <div v-if="chartData.dataTrendList.length === 0">
      <el-empty style="margin-top: 20px" description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getPurchaseIncomeTrendData } from "@/api/bi-board";
// import { sortBy, reverse, join } from "lodash";
export default {
  components: {},
  props: {
    formSearch: Object,
    title: String,
    fieldKey: String,
  },
  data() {
    return {
      chartLoading: false,
      myChart: null,
      chartData: {
        dataTrendList: [],
      },
    };
  },

  computed: {},

  methods: {
    setLoading(loading) {
      this.chartLoading = loading;
    },
    getCharts() {
      this.chartLoading = true;
      const {
        formdate,
        geo,
        afid,
        platform,
        team,
        mediaList,
        accountGroupCodes,
      } = this.formSearch;
      getPurchaseIncomeTrendData({
        dateStart: formdate[0],
        dateEnd: formdate[1],
        top: this.topType,
        geo: geo.join(",") || null,
        afid: afid.join(",") || null,
        team: team.join(",") || null,
        platform,
        dimension: 3,
        mediaList,
        accountGroupCodes: accountGroupCodes ? [accountGroupCodes] : undefined,
      }).then((res) => {
        this.chartData = JSON.parse(JSON.stringify(res.data));
        if (this.chartData?.dataTrendList?.length > 0) {
          setTimeout(() => {
            this.myChart?.dispose();
            let chartDom = this.$refs.chartRef;
            let myChart = echarts.init(chartDom);
            window.onresize = myChart.resize;
            this.myChart = myChart;
            this.renderData();
          }, 0);
        } else {
          this.chartLoading = false;
        }
      }).catch((error) => {
        console.error('内购收入趋势加载失败:', error);
      }).finally(() => {
        this.chartLoading = false;
      });
    },
    renderData() {
      this.chartLoading = true;
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData?.dataTrendList?.map((item) => item.installDay),
            // axisLabel: { rotate: 30 },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "内购收入",
            type: "bar",
            barWidth: "60%",
            data: this.chartData?.dataTrendList?.map(
              (item) => item.purchaseIncome
            ),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" },
              ]),
            },
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      this.chartLoading = false;
      this.myChart.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.chart-field {
  margin-top: 20px;
  .chart-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
  }
}
</style>
